import React from 'react'
import {useShare} from 'hooks/useShare'
import {SearchProps} from 'utils/sharing'

import {ButtonLink} from '@vio/atlas/ButtonLink'
import {Icon} from '@vio/atlas/Icon'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {myListMessages} from '@vio/shared/src/priceWatch/myListMessages'

import {ShareComponent, ShareType} from './constants'

interface Props {
  shareParams: SearchProps
  component: ShareComponent
  className?: string
}

export const LinkShareButton = ({shareParams, component, className}: Props) => {
  const {onShare} = useShare({
    shareParams,
    component,
    shareType: ShareType.ShareLink
  })

  // An anchor without an href ignores Enter and Space on its own
  const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onShare()
  }

  return (
    <ButtonLink
      className={className}
      role="button"
      tabIndex={0}
      dataId="ShareButton"
      onClick={onShare}
      onKeyDown={handleKeyDown}
      iconStart={<Icon name="Share3" size="sm" />}
    >
      <FormattedMessageWrapper {...myListMessages.share} />
    </ButtonLink>
  )
}
